/**
 * Decode the payload of a JWT token without verifying the signature.
 * Handles both standard and URL-safe base64 encoding.
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}
